import { IntegrationService, IntegrationServiceAuthKey } from '../types';

export const INTEGRATION_SERVICE_TO_AUTH_KEY = {
  [IntegrationService.GONG]: IntegrationServiceAuthKey.GONG,
  [IntegrationService.SALESLOFT]: IntegrationServiceAuthKey.SALESLOFT,
};
